import { Container, Row, Col } from "react-bootstrap";

const Footer = () => {
  const footerYear = new Date().getFullYear();
  return (
    <>
      <footer>
        <Container>
          <Row>
            <Col className="text-center py-3">
              <p>zpotter Technologies &copy; {footerYear}</p>
              <label style={{ fontSize: "0.8rem", color: "grey" }}>
                {" "}
                Version 2.0.0
              </label>
            </Col>
          </Row>
        </Container>
      </footer>
    </>
  );
};

export default Footer;
